import React, { useState, useEffect } from 'react';
import { callAPI } from '../utils/apiUtils';
import { apiUrls } from '../utils/apiUrls';

export default function Promotion({
  ready = true,
  orderId,
  tableId,
  paymentMethod,
  selectedOfferId,
  onOfferSelect
}) {
  const [promotions, setPromotions] = useState([]);
  const [selectedOffer, setSelectedOffer] = useState(selectedOfferId || null);

  // Safety net for a restaurant whose tender list never answers: after this long the offers are
  // asked for without a payment method rather than never being shown.
  const [gaveUpWaiting, setGaveUpWaiting] = useState(false);
  useEffect(() => {
    if (!ready || paymentMethod != null) return undefined;
    const t = setTimeout(() => setGaveUpWaiting(true), 5000);
    return () => clearTimeout(t);
  }, [ready, paymentMethod]);

  useEffect(() => {
    if (selectedOfferId !== undefined) {
      setSelectedOffer(selectedOfferId);
    }
  }, [selectedOfferId]);

  useEffect(() => {
    const fetchPromotions = async () => {
      if (!ready) return; // the order / table id has not been read yet
      if (!orderId && !tableId) return;
      // The offers depend on how the order is paid. Until the payment method is chosen (the tender
      // list loads first and picks the default) asking would only give an answer that is replaced a
      // moment later, so wait for it - the same rule the checkout summary follows.
      if (paymentMethod == null && !gaveUpWaiting) return;

      let url = `${apiUrls.OFFERS_LOYALTY_POINTS}?type=offers`;
      if (paymentMethod) url += `&payment_mode=${paymentMethod}`;
      if (tableId) url += `&table_id=${tableId}`;
      else if (orderId) url += `&order_id=${orderId}`;

      try {
        // withLoader=false - promotions are secondary; don't hold the
        // global loader open waiting on this while the rest of checkout
        // (cart items, summary, tender view) is already usable.
        const res = await callAPI(url, {}, 'GET', null, {}, {}, false);
        setPromotions(res?.data?.data?.promotions || []);
      } catch (err) {
        console.error('Failed to load promotions', err);
      }
    };

    fetchPromotions();
  }, [ready, orderId, tableId, paymentMethod, gaveUpWaiting]);

  const handleChange = (promo) => {
    setSelectedOffer(promo.id);
    onOfferSelect?.(promo); // pass full promo like PHP
  };

  return (
    <div className="promotionsCol mb-3">
      <h4 className="lgTitle">Promotions</h4>

      {promotions.length === 0 ? (
        <p className="text-muted">No promos available</p>
      ) : (
      <div className="promotionsInnerCol">

      
      <div className="form-check">
        <input
          className="form-check-input"
          type="radio"
          name="promotionRadio"
          id="promo-none"
          checked={selectedOffer === null}
          onChange={() => {
            setSelectedOffer(null);
            onOfferSelect?.(null);
          }}
        />
        <label className="form-check-label" htmlFor="promo-none">
          No Promotion
        </label>
      </div>

      {promotions.map((promo) => (
        <div className="form-check" key={promo.id}>
          <input
            className="form-check-input"
            type="radio"
            name="promotionRadio"
            id={`promo-${promo.id}`}
            checked={selectedOffer === promo.id}
            onChange={() => handleChange(promo)}
          />
          <label className="form-check-label" htmlFor={`promo-${promo.id}`}>
            {promo.promocode} ({promo.details})
          </label>
        </div>
      ))}
      </div>
      )}
    </div>
  );
}
